import { render, staticRenderFns } from "./ManejoConsultas.vue?vue&type=template&id=5494f790"
import script from "./ManejoConsultas.vue?vue&type=script&lang=js"
export * from "./ManejoConsultas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports